import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "px-4 py-16 mx-auto sm:px-4 lg:px-6" }
const _hoisted_3 = { class: "grid grid-cols-1 gap-4 border-2 border-teal-600 rounded-xl sm:grid-cols-2 lg:grid-cols-4" }
const _hoisted_4 = { class: "p-8" }
const _hoisted_5 = { class: "text-2xl font-extrabold text-teal-500" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-lg font-medium" }, "Current Turnout", -1)
const _hoisted_7 = { class: "p-8" }
const _hoisted_8 = { class: "text-2xl font-extrabold text-teal-500" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-lg font-medium" }, "Yays", -1)
const _hoisted_10 = { class: "p-8" }
const _hoisted_11 = { class: "text-2xl font-extrabold text-teal-500" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-lg font-medium" }, "Nays", -1)
const _hoisted_13 = { class: "p-8" }
const _hoisted_14 = { class: "text-2xl font-extrabold text-teal-500" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-lg font-medium" }, "Awaiting", -1)

import { useVoteStore } from "@/stores/votes";
import { PropType, computed } from "vue";

export default /*#__PURE__*/_defineComponent({
  props: {
  vote: {
    type: Object as PropType<Vote>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const voteStore = useVoteStore();

const total_homes = computed(() => voteStore.total_homes);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(((__props.vote.total_ballots_cast / _unref(total_homes)) * 100).toFixed(2)) + "% ", 1),
          _hoisted_6
        ]),
        _createElementVNode("li", _hoisted_7, [
          _createElementVNode("p", _hoisted_8, _toDisplayString(__props.vote.total_yays), 1),
          _hoisted_9
        ]),
        _createElementVNode("li", _hoisted_10, [
          _createElementVNode("p", _hoisted_11, _toDisplayString(__props.vote.total_nays), 1),
          _hoisted_12
        ]),
        _createElementVNode("li", _hoisted_13, [
          _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(total_homes) - __props.vote.total_ballots_cast - 1) + " Homes ", 1),
          _hoisted_15
        ])
      ])
    ])
  ]))
}
}

})